import { useState } from 'react'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import Select from 'components/Inputs/Select'
import MoneyInput from 'components/Inputs/MoneyInput'
import MainButton from 'components/Buttons/MainButton'
import DateInput from 'components/Inputs/DateInput'
import submitOnEnter from 'utils/submitOnEnter'
import professionalCreditsValidator from 'validators/professionalCreditsValidator'
import { Formik } from 'formik'
import { DateTime } from 'luxon'

import {
  Form,
  FormField,
  Input,
  Row,
  Label,
  InfoText,
  WarningText,
  ErrorContainer
} from './styles'

export default function AddProfessionalCreditModal ({
  visible,
  professionals,
  onConfirm: handleConfirm = () => null,
  onClose: handleClose
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Adicionar bônus</DialogTitle>
        </DialogHeader>
        <Formik
          validationSchema={professionalCreditsValidator}
          initialValues={{
            'professional': null,
            'description': '',
            'value': 0,
            'date': DateTime.now ().toFormat ('yyyy-MM-dd')
          }}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              const creditValues = {
                ...values,
                professionalId: values.professional.value.id
              }

              const { data: credit } = await cutileiApi.post (
                `/businesses/${businessId}/credits`, creditValues, requestConfig
              )

              setSubmitting (false)
              handleConfirm (credit)
              handleClose ()
            } catch (error) {
              setErrorMessage (getApiErrorMessage (error))
              setSubmitting (false)
              logApiError (error)
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
            handleChange,
            handleBlur,
            handleSubmit
          }) => {
            return (
              <>
                <DialogBody>
                  <Form onKeyDown={submitOnEnter(handleSubmit, isSubmitting)}>
                    <Row>
                      <FormField>
                        <Select
                          name='professional'
                          placeholder='Profissional...'
                          value={values.professional}
                          options={professionals.map (professional => ({
                            label: professional.nickname,
                            value: professional
                          }))}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          error={errors.professional}
                          touched={touched.professional}
                        />
                        {touched.professional && errors.professional && (
                          <WarningText>
                            {errors.professional}
                          </WarningText>
                        )}
                      </FormField>
                      <FormField>
                        <Input 
                          placeholder='Descrição'
                          value={values.description}
                          onChange={handleChange ('description')} 
                          onBlur={handleBlur ('description')}
                        />
                        {touched.description && errors.description && (
                          <WarningText>
                            {errors.description}
                          </WarningText>
                        )}
                      </FormField>
                    </Row>
                    <Row>
                      <FormField>
                        <Label>Valor</Label>
                        <MoneyInput
                          name='value'
                          placeholder='Valor'
                          value={values.value}
                          onValueChange={setFieldValue}
                          onBlur={handleBlur ('value')}
                        />
                        {touched.value && errors.value && (
                          <WarningText>
                            {errors.value}
                          </WarningText>
                        )}
                      </FormField>
                      <FormField>
                        <Label>Data referente</Label>
                        <DateInput
                          placeholder='Data referente'
                          value={values.date}
                          onChange={date => setFieldValue('date', date)}
                          style={{width: '100%'}}
                        />
                        {touched.date && errors.date && (
                          <WarningText>
                            {errors.date}
                          </WarningText>
                        )}
                      </FormField>
                    </Row>
                    {errorMessage && (
                      <ErrorContainer>
                        <InfoText>{errorMessage}</InfoText>
                      </ErrorContainer>
                    )}
                  </Form>
                </DialogBody>
                <DialogFooter>
                  <MainButton
                    label='Adicionar bônus'
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    width={180}
                  />
                </DialogFooter>
              </>
            )
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
